export default __webpack_public_path__ + "static/1_24-b6774a393991ee97af10558b7fcc93f6.png";